
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import ProfileForm from '@/components/profile/ProfileForm';
import { SEO } from '@/components/SEO';

const ProfileEdit = () => {
  const navigate = useNavigate();

  const { data: session, isLoading: isSessionLoading } = useQuery({
    queryKey: ['session'],
    queryFn: async () => {
      const { data: { session }, error } = await supabase.auth.getSession();
      if (error) throw error;
      return session;
    },
  });

  useEffect(() => {
    if (!isSessionLoading && !session) {
      navigate('/auth');
    }
  }, [session, isSessionLoading, navigate]);

  if (isSessionLoading) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="flex items-center justify-center min-h-[50vh]">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
        </div>
      </div>
    );
  }

  return (
    <>
      <SEO 
        title="Edit Profile" 
        description="Update your profile information on Travilis." 
      />
      <ProfileForm />
    </>
  );
};

export default ProfileEdit;
